export default {
  title: 'Adresă de livrare',
  buttons: {
    save: 'Salvați',
  },
};
